var recaptchaCallback = function() {
    // https://developers.google.com/recaptcha/docs/display#render_param
    var nl_spanId = $('.nl_captcha label span').attr('id');
    submit_form_btn = $('.btn-submit-popup-newsletter');
    submit_form_btn.addClass("btn-contact-disabled");
    /* Rendering captcha */

    var renderId = grecaptcha.render(nl_spanId, {
        'sitekey': "6LeOSdofAAAAADH-XaXQJWpaVjgzSztUYpROugwl",
        'callback': function() {
            submit_form_btn.removeClass("btn-contact-disabled")
        },
        'expired-callback': function() {
            $("#news-letter-signup-button").addClass("btn-contact-disabled")
        }
    })
    setTimeout(() => {
        grecaptcha.reset(renderId);
    }, 2000);
}
